module.exports = __webpack_public_path__ + "img/62.3a57a17d.jpg";